import { useMediaQuery, useTheme } from '@mui/material';

type TBreakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

function useIsBreakpoint(breakpoint: TBreakpoint) {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.only(breakpoint));
}

export function useIsDesktop() {
  return useIsBreakpoint('md');
}
